{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Pantalla completa",
		"achievements": "Logros",
		"reset": "Reiniciar",
		"language": "Idioma"
	},
	"achievements": {
		"title": "Logros",
		"noAchievements": "Aún no hay logros conseguidos. ¡Sigue haciendo clic!",
		"unlocked": "¡Logro desbloqueado: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Conejito Principiante",
		"carrotSnatcher": "🥕 Ladrón de Vegetales",
		"bunnyBerserker": "😡 Furia Desatada",
		"hopPunk": "🎸 Conejito Anarquista",
		"bunnyNinja": "🥷 Silencioso pero Mortal",
		"expert": "🌟 Saltarín Experto",
		"master": "👑 Rey Zanahoria",
		"carrotpocalypse": "🥕 Destructor de Huertos",
		"bunnyOverlord": "😈 Líder Supremo de la Madriguera",
		"chaosHare": "🌪️ Agente del Caos",
		"carrotCultist": "⛪ Sumo Sacerdote del Culto a la Zanahoria",
		"bunnyberryPie": "🥧 Maestro del Pastel Alucinógeno",
		"rabbitHole": "🕳️ Excavador de Túneles Cuánticos",
		"moonRabbit": "🌙 Conejo Lunar",
		"bunnyDoom": "💀 Heraldo del Conejocalipsis",
		"carrotNuke": "☢️ Portador de la Zanahoria Nuclear",
		"bunnyMatrix": "🤖 Fallo en la Matriz Conejil",
		"cosmicHare": "🌌 La Liebre Cósmica Despierta",
		"warrenSingularity": "🕳️ Singularidad de la Madriguera Alcanzada",
		"eternalBunny": "♾️ El Conejo Eterno"
	},

	"messages": {
		"prophecy": "¡La antigua profecía de clics comienza a revelarse...",
		"cosmic": "¡Los clickers cósmicos estarían orgullosos de tu progreso!",
		"astral": "Los clics resuenan a través del plano astral...",
		"speaking": "Espera... ¿escuchaste eso? ¡Los clics me están hablando!",
		"ancient": "¡Tus clics resuenan con poder ancestral!",
		"sages": "Los Sabios del Clic susurran sobre tu potencial...",
		"demons": "¡CONTEMPLA! ¡Los Demonios del Clic despiertan de su letargo!",
		"veil": "¡Tus clics atraviesan el velo de la realidad!",
		"spirits": "Los Espíritus del Clic bailan a tu ritmo...",
		"council": "El Gran Consejo del Clic ha notado tu dedicación",
		"primordial": "¡Tus clics despiertan fuerzas primordiales!",
		"void": "El vacío de los clics te devuelve la mirada...",
		"runes": "¡Las antiguas runas del clic brillan con tu poder!",
		"beast": "TRES TRES TRES - EL NÚMERO DE LA BESTIA DEL CLIC",
		"prophets": "¡Los Profetas del Clic cantan sobre tu llegada!",
		"dimensions": "Tus clics resuenan a través de las dimensiones...",
		"portal": "¡Tus clics han abierto un portal a la Dimensión del Clic!",
		"sacrifice": "Los antiguos Dioses del Clic exigen MÁS SACRIFICIO",
		"jackpot": "¡PREMIO GORDO! ¡El Casino del Clic da la bienvenida a su nuevo campeón!",
		"unmatched": "¡Tu poder de clics no tiene igual!",
		"reality": "¡La realidad misma se dobla ante tu voluntad de clics!",
		"elite": "TE HAS CONVERTIDO EN EL MAESTRO ÉLITE DEL CLIC",
		"power": "¡Tu nivel de poder de clics supera los 1500!",
		"devils": "Los Demonios del Clic se inclinan ante tu poder",
		"lucky": "Los clics afortunados fluyen por tus venas",
		"dynasty": "La Dinastía del Clic reconoce tu supremacía",
		"twoThousand": "¡Dos mil clics de puro poder!",
		"quartet": "¡La profecía del Cuarteto del Clic se ha cumplido!",
		"transcend": "Tus clics trascienden el entendimiento mortal",
		"constellation": "La Constelación del Clic se alinea en tu honor",
		"destiny": "TRES MIL CLICS DEL DESTINO",
		"triforce": "¡La Triple Trifuerza del Clic despierta!",
		"fortune": "La fortuna favorece al clicker persistente",
		"newDimensions": "Tu poder de clics alcanza nuevas dimensiones",
		"quartet2": "El Cuádruple Cuarteto del Clic armoniza",
		"threshold": "De pie en el umbral de la divinidad del clic",
		"ultimate": "¡CINCO MIL CLICS DE PODER SUPREMO!",
		"force": "La Fuerza de los Cinco Dedos del Clic está bajo tu mando",
		"underworld": "El Inframundo del Clic te corona como su gobernante",
		"maxJackpot": "¡PREMIO GORDO MÁXIMO DE CLICS CONSEGUIDO!",
		"infinite": "¡PODER DE CLICS INFINITO!",
		"godhood": "HAS ASCENDIDO A LA DIVINIDAD DEL CLIC",
		"burrow": "Has cavado más profundo que cualquier conejo antes...",
		"warren": "La Gran Madriguera reconoce tu presencia...",
		"thump": "¡La tierra tiembla con cada golpe de tu pata!",
		"darkWarren": "La Madriguera Oscura abre sus puertas para ti...",
		"ears": "Tus orejas crecen más largas... ahora puedes oír todo...",
		"carrotThrone": "El Trono de la Zanahoria se materializa ante ti...",
		"onesAlignment": "¡Todos los unos se alinean - la Frecuencia de la Madriguera resuena!",
		"moonSummon": "El Conejo Lunar oye tu llamada a través del vacío...",
		"edgeOfForever": "Estás al borde de la eternidad... orejas temblando...",
		"beyondTheVeil": "Más allá del velo, todas las madrigueras se unen...",
		"sequence": "1-2-3-4-5... ¡La Secuencia Sagrada del Salto está completa!",
		"hyperElite": "ESTADO HIPER ÉLITE DESBLOQUEADO 🐇🐇🐇",
		"eventHorizon": "Más allá del horizonte de eventos de la Madriguera Cósmica...",
		"matrixAwakens": "La Matriz de la Madriguera falla... ves las zanahorias detrás de la realidad",
		"luckyForever": "Cada pata, cada salto, cada temblor... bendecido para siempre",
		"twentyK": "VEINTE MIL. Ya no eres un conejo. Eres EL conejo.",
		"singularity": "La Singularidad Conejil. Todos los conejos eres tú. Tú eres todos los conejos.",
		"tripleAscension": "¡La Triple Ascensión de la Liebre Cósmica!",
		"ultimateAnswer": "42.000 - La Respuesta Definitiva siempre fueron las zanahorias",
		"eternity": "♾️ LA MADRIGUERA ETERNA NO TIENE FIN. TÚ TAMPOCO. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 ¡+{{count}} Puntos Extra!",
		"clickStreak": "🔥 ¡{{count}} Clics Seguidos!",
		"fire": "🔥 ¡Poder de Fuego Activado!"
	},
	"table": {
		"achievement": "Logro",
		"progress": "Progreso"
	},
	"reset": {
		"confirm": "¿Estás seguro de que quieres reiniciar todo el progreso? Esta acción no se puede deshacer."
	}
}
